/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Side_BothInputs */

const en_us2_workout_logging_side_both = /** @type {(inputs: Workout_Logging_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both`)
};

const pt_br2_workout_logging_side_both = /** @type {(inputs: Workout_Logging_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dois`)
};

const es_419_workout_logging_side_both = /** @type {(inputs: Workout_Logging_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambos`)
};

const pt_pt2_workout_logging_side_both = /** @type {(inputs: Workout_Logging_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dois`)
};

const fr_fr2_workout_logging_side_both = /** @type {(inputs: Workout_Logging_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux`)
};

const de_de2_workout_logging_side_both = /** @type {(inputs: Workout_Logging_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beide`)
};

const it_it2_workout_logging_side_both = /** @type {(inputs: Workout_Logging_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrambi`)
};

/**
* | output |
* | --- |
* | "Both" |
*
* @param {Workout_Logging_Side_BothInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_side_both = /** @type {((inputs?: Workout_Logging_Side_BothInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Side_BothInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_side_both(inputs)
	if (locale === "es-419") return es_419_workout_logging_side_both(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_side_both(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_side_both(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_side_both(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_side_both(inputs)
	return en_us2_workout_logging_side_both(inputs)
});
export { workout_logging_side_both as "workout-logging.side_both" }